module.exports = __webpack_public_path__ + "static/media/person-white.095d89f8.svg";